import { useParams } from 'wouter';
import { AdminDetailPage } from '../../AdminDetailPage';
import { useState } from 'react';
import { EditCohortModal } from './EditCohortModal';
import { AdminCohorts } from '@platform/client';
import { DetailsTabContent } from './DetailsTabContent';

export const CohortDetail = () => {
  const { cohortId } = useParams<{ cohortId: string }>();
  const [editCohortModalOpen, setEditCohortModalOpen] = useState(false);
  const {
    data: cohortData,
    isSuccess,
    isError,
    isLoading,
  } = AdminCohorts.useGetCohortDetails(parseInt(cohortId));

  return (
    <>
      <AdminDetailPage
        isError={isError}
        isLoading={isLoading}
        isSuccess={isSuccess}
        title={cohortData?.name || 'Cohort Details'}
        tabs={[{ id: 'Details', content: <DetailsTabContent cohortData={cohortData} /> }]}
        pageActions={[
          {
            text: 'Edit',
            onPress: () => setEditCohortModalOpen(true),
            type: 'button',
          },
        ]}
      />
      {editCohortModalOpen && (
        <EditCohortModal
          cohortId={parseInt(cohortId)}
          onClose={() => setEditCohortModalOpen(false)}
        />
      )}
    </>
  );
};
